.Section {
  --rounded-padding-overlap-adjustment: 0px;
  --rounded-radius: var(--brand-borderRadius-xlarge);
  --padding-block-end: var(--brand-Section-padding-normal);
  --adjusted-padding-block-end: calc(var(--padding-block-end) + var(--rounded-padding-overlap-adjustment));

  background-repeat: no-repeat;
  background-color: var(--brand-Section-narrow-background-color, var(--brand-Section-background-color));
  background-image: var(--brand-Section-narrow-background-image-src, var(--brand-Section-background-image-src));
  background-size: var(--brand-Section-narrow-background-image-size, var(--brand-Section-background-image-size));

  background-position: var(
    --brand-Section-narrow-background-image-position,
    var(--brand-Section-background-image-position, center)
  );

  padding-block-start: var(--padding-block-start);
  padding-block-end: var(--adjusted-padding-block-end);
}

.Section__container {
  width: 100%;
  max-width: var(--brand-Section-container-maxWidth);
  margin-inline: auto;
}

.Section__container--fullWidth {
  max-width: none;
}

.Section--rounded {
  border-radius: var(--rounded-radius) var(--rounded-radius) 0 0;
  margin-top: calc(-1 * var(--rounded-radius));
}

/* A progressive enhancment to adjust block-end padding to account for adjacent section rounded corners overlap. */
.Section:has(+ .Section--rounded) {
  --rounded-padding-overlap-adjustment: var(--rounded-radius);
}

.Section--paddingBlockStart-none,
.Section-narrow--paddingBlockStart-none {
  padding-block-start: 0;
}

.Section--paddingBlockStart-condensed,
.Section-narrow--paddingBlockStart-condensed {
  padding-block-start: var(--brand-Section-padding-condensed);
}
.Section--paddingBlockStart-normal,
.Section-narrow--paddingBlockStart-normal {
  padding-block-start: var(--brand-Section-padding-normal);
}
.Section--paddingBlockStart-spacious,
.Section-narrow--paddingBlockStart-spacious {
  padding-block-start: var(--brand-Section-padding-spacious);
}

.Section--paddingBlockEnd-none,
.Section-narrow--paddingBlockEnd-none {
  --padding-block-end: 0px;
}

.Section--paddingBlockEnd-condensed,
.Section-narrow--paddingBlockEnd-condensed {
  --padding-block-end: var(--brand-Section-padding-condensed);
}
.Section--paddingBlockEnd-normal,
.Section-narrow--paddingBlockEnd-normal {
  --padding-block-end: var(--brand-Section-padding-normal);
}
.Section--paddingBlockEnd-spacious,
.Section-narrow--paddingBlockEnd-spacious {
  --padding-block-end: var(--brand-Section-padding-spacious);
}

@media screen and (min-width: 48rem) {
  .Section {
    background-color: var(--brand-Section-regular-background-color, var(--brand-Section-background-color));
    background-image: var(--brand-Section-regular-background-image-src, var(--brand-Section-background-image-src));
    background-size: var(--brand-Section-regular-background-image-size, var(--brand-Section-background-image-size));
    background-position: var(
      --brand-Section-regular-background-image-position,
      var(--brand-Section-background-image-position)
    );
  }

  .Section-regular--paddingBlockStart-none {
    padding-block-start: 0;
  }

  .Section-regular--paddingBlockStart-condensed {
    padding-block-start: var(--brand-Section-padding-condensed);
  }
  .Section-regular--paddingBlockStart-normal {
    padding-block-start: var(--brand-Section-padding-normal);
  }
  .Section-regular--paddingBlockStart-spacious {
    padding-block-start: var(--brand-Section-padding-spacious);
  }

  .Section-regular--paddingBlockEnd-none {
    --padding-block-end: 0px;
  }

  .Section-regular--paddingBlockEnd-condensed {
    --padding-block-end: var(--brand-Section-padding-condensed);
  }
  .Section-regular--paddingBlockEnd-normal {
    --padding-block-end: var(--brand-Section-padding-normal);
  }
  .Section-regular--paddingBlockEnd-spacious {
    --padding-block-end: var(--brand-Section-padding-spacious);
  }
}

@media screen and (min-width: 80rem) {
  .Section {
    background-color: var(--brand-Section-wide-background-color, var(--brand-Section-background-color));
    background-image: var(--brand-Section-wide-background-image-src, var(--brand-Section-background-image-src));
    background-size: var(--brand-Section-wide-background-image-size, var(--brand-Section-background-image-size));

    background-position: var(
      --brand-Section-wide-background-image-position,
      var(--brand-Section-background-image-position)
    );
  }

  .Section-wide--paddingBlockStart-none {
    padding-block-start: 0;
  }

  .Section-wide--paddingBlockStart-condensed {
    padding-block-start: var(--brand-Section-padding-condensed);
  }
  .Section-wide--paddingBlockStart-normal {
    padding-block-start: var(--brand-Section-padding-normal);
  }
  .Section-wide--paddingBlockStart-spacious {
    padding-block-start: var(--brand-Section-padding-spacious);
  }

  .Section-wide--paddingBlockEnd-none {
    --padding-block-end: 0px;
  }

  .Section-wide--paddingBlockEnd-condensed {
    --padding-block-end: var(--brand-Section-padding-condensed);
  }
  .Section-wide--paddingBlockEnd-normal {
    --padding-block-end: var(--brand-Section-padding-normal);
  }
  .Section-wide--paddingBlockEnd-spacious {
    --padding-block-end: var(--brand-Section-padding-spacious);
  }
}
